import { useParams } from "react-router-dom";

import { useEffect, useState } from "react";
import axios from "axios";
import QuestionsP1 from "../themes/phase1/QuestionsP1";
import QuestionsP2 from "../themes/phase2/QuestionsP2";
import QuestionsP3 from "../themes/phase3/QuestionsP3";
import QuestionsP4 from "../themes/phase4/QuestionsP4";
import QuestionsP5 from "../themes/phase5/QuestionsP5";

export default function DynamicQuestionHandler() {
  const { phaseTitle } = useParams();

  if (phaseTitle === "Phase 1") return <QuestionsP1 />;
  if (phaseTitle === "Phase 2") return <QuestionsP2 />;
  if (phaseTitle === "Phase 3") return <QuestionsP3 />;
  if (phaseTitle === "Phase 4") return <QuestionsP4 />;
  if (phaseTitle === "Phase 5") return <QuestionsP5 />;
}
